export function RetrieveUsername() {
  return (
    <div>
      <p>Retrieve Username Component</p>
    </div>
  );
}
